import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import DialogActions from "@material-ui/core/DialogActions";
import Typography from '@material-ui/core/Typography';

//Lib
import { parseWaypointPairs } from "../../libs/geoLib";
//Component
import TollRenderer from "../Ui/Renderer/TollRenderer";
import AddBtnRenderer from "./Renderer/AddBtnRenderer";
import SecToTimeRenderer from "../Ui/Renderer/SecToTimeRenderer";
import DistanceRenderer from "../Ui/Renderer/DistanceRenderer";
//Reducer
import {
  apiCallRequest,
  apiCallSuccess
} from '../../reducers/api';
import { getCandidateRoutes } from "../../reducers/map/api";
import { MAP_SELECT_CANDIDATE
  ,mapResetMap ,
  SELECT_MASTER_OR_CANDIDATE,
  mapSetCandidateWaypoints,
  SET_MARKER_ORIGIN_DESC} from "../../reducers/map";

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '10px',
  },
  textField: {
    margin:0,
    //marginLeft: theme.spacing.unit,
    //marginRight: theme.spacing.unit,
    width: 200,
  },
});
class CandidateRoutes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toll : 0,
      columnDefs: [
        { 
          headerName: "ADD", 
          field: "Vehicle" ,
          cellRenderer: "addBtnRenderer",
          width: 35
        },{ 
          headerName: "ROUTE", 
          field: "Vehicle" ,
          width: 80,
          autoHeight: true
        },{ 
          headerName: "DISTANCE", 
          field: "TotalDistance" ,
          cellRenderer : "distanceRenderer",
          width: 75,
          autoHeight: true
        },{ 
          headerName: "DURATION", 
          field: "TotalTime" ,
          cellRenderer : "secToTimeRenderer",
          width: 120,
          autoHeight: true
        },
        { 
          headerName: "TOLL", 
          field: "TollUsage" ,
          width: 50,
          autoHeight: true,
          cellRenderer: "tollRenderer",
        }
        
      ],
      rowData: null,
      context: { componentParent: this },
      suppressRowClickSelection: true,
      rowSelection: "multiple",
      frameworkComponents: {
        tollRenderer : TollRenderer,
        addBtnRenderer: AddBtnRenderer,
        secToTimeRenderer : SecToTimeRenderer,
        distanceRenderer : DistanceRenderer,
      },
    };
  }
  componentDidMount() {
      
  }
  componentWillUnmount() {
    
  }
  componentDidUpdate () {
    this.props.SET_MARKER_ORIGIN_DESC(
      { 
          marker_origin : {
                lat : this.props.logisticRouteForm.originLat , 
                lng : this.props.logisticRouteForm.originLng
              },
          marker_desc : {
                lat : this.props.logisticRouteForm.destinationLat , 
                lng : this.props.logisticRouteForm.destinationLng
              }
        }
    )
    this.autoSizeAll();
  }
  //Grid
  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  sizeToFit = () => {
    this.gridApi.sizeColumnsToFit();
  }
  autoSizeAll = () => {
    // var allColumnIds = [];
    // if(this.gridColumnApi){

    //   this.gridColumnApi.getAllColumns().forEach(function(column,index) {
    //     if(index!=0)allColumnIds.push(column.colId);
    //   });
    //   this.gridColumnApi.autoSizeColumns(allColumnIds);
    // }
  }

  componentWillReceiveProps(nextProps) {
    this.focusRow(nextProps.candidate_selecting)
  }
  
  focusRow = (candidate_selecting) => {
    let gridApi = this.gridApi
    if(gridApi){
      gridApi.deselectAll()
      this.gridApi.forEachNode(function(node) {
        if (node.data.Vehicle === candidate_selecting) {

          node.setSelected(true,true);
          gridApi.ensureIndexVisible(node.rowIndex, { position: 'top' }); 

          // and ensureNodeVisible(event.node, { position: 'top' });
        }

      });


    }
  }

  getCandidateRoutes = () =>{
    let f = this.props.logisticRouteForm;
    let body = {
      list: [{
        transportMode: "truck",
        origin: f.originLat + "," + f.originLng,
        destination: f.destinationLat + "," + f.destinationLng,
        waypoints: [],
        returns: ["polyline", "summary", "tolls"],
        // Always allow toll so candidates include toll routes (flagged via
        // TollUsage) alongside non-toll alternatives. The backend's only_toll
        // branch adds toll-avoiding variants when the natural route is toll-only.
        avoid: [],
        routingMode: "fast",
        alternatives: 3,
      }],
    };

    this.props.RESET_MAP(true);
    this.props.GET_CANDIDATE({ body: body });
  }
  renderData = () => {
    if (Array.isArray(this.props.candidate_routes)) {

      return this.props.candidate_routes;
    } else return [];
  }
  handleSelectionChanged = node => {
    var selectedRows = node.api.getSelectedRows();

    this.props.SELECT_MASTER_OR_CANDIDATE(2)
    this.props.MAP_SELECT_CANDIDATE(selectedRows[0].Vehicle);

    // The backend returns waypoints as nested [[lat, lng], ...] pairs
    // (parseWaypointPairs also accepts legacy flat); the map renders them as
    // {lat, lng} circle points.
    let waypoints = parseWaypointPairs(selectedRows[0].waypoints).map(
      ([lat, lng]) => ({ lat, lng })
    );
    this.props.SET_CANDIDATE_WAYPOINTS(waypoints);
  }
  handleChangeToll = () =>{
    this.setState({toll:this.state.toll===1 ? 0 : 1});
  }
  render() {
    return (
      <div style={{ width: "100%", height: "180px" ,padding:'5px'}}>
        <div
          className="ag-theme-balham"
          style={{
            height: "150px",
            width: "100%",
          }}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <DialogActions>
                <Typography variant="subheading">CANDIDATE ROUTES : </Typography>
                {/* <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.toll==1 ? 'checked' : ''}
                      value="toll"
                      onChange={this.handleChangeToll}
                      color="primary"
                    />
                  }
                  label="Toll"
                /> */}
                <Button 
                    variant="contained" size="small"  color="primary" 
                    aria-label="Add" className={classNames(styles.button)} 
                    onClick={this.getCandidateRoutes}>
                    GET
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <AgGridReact
            enableSorting={true}
            singleClickEdit={true}
            suppressMovableColumns={true}
            enableColResize={true}
            columnDefs={this.state.columnDefs}
            rowData={this.renderData()}
            rowSelection="single"
            onGridReady={this.onGridReady}
            onRowClicked={this.handleSelectionChanged}
            frameworkComponents={this.state.frameworkComponents}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = function(state,ownProps) {
  return {
    isLoading : state.api.fetching,
    candidate_routes: state.map.candidate_routes,
    logisticRouteForm : state.mapForm.logisticRouteForm,
    candidate_selecting : state.map.candidate_selecting,
  }  
};
const mapActionsToProps =  {
  getRequest : apiCallRequest,
  success : apiCallSuccess,
  RESET_MAP: mapResetMap,
  GET_CANDIDATE : getCandidateRoutes,
  SELECT_MASTER_OR_CANDIDATE : SELECT_MASTER_OR_CANDIDATE,
  MAP_SELECT_CANDIDATE,
  SET_CANDIDATE_WAYPOINTS : mapSetCandidateWaypoints,
  SET_MARKER_ORIGIN_DESC
};

export default compose(
  connect(
    mapStateToProps,
    mapActionsToProps,
    //mapDispatchToProps
  ),
  withStyles(styles)
)(CandidateRoutes);
